/* eslint-disable object-curly-newline */
import getDefaultState from './get-default-state';

export default {
  setErrorInfos(state, { message, httpStatusCode, appCode }) {
    state.message = message;
    state.httpStatusCode = httpStatusCode;
    state.appCode = appCode;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
